import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'

const propTypes = {
  is_active: PropTypes.bool
}

/**
 * @param {string} status
 */
const PaymentMethodStatusBadge = ({ is_active }) => {
  const color = is_active ? 'success' : 'danger'

  const label = is_active ? 'enabled' : 'disabled'

  return <StatusBadge color={ color } label={ label } />
}

PaymentMethodStatusBadge.propTypes = propTypes

export default PaymentMethodStatusBadge